import Splide from '@splidejs/splide';
import Fancybox from '@fancyapps/fancybox';

$(function() {

	/**
	 * IE-Object-Fit
	 */

    var userAgent = window.navigator.userAgent;
    var internetExplorer = userAgent.search(/(MSIE|Trident|Edge)/);

    // make <div>s out of <img>s with object-fit
    if(internetExplorer > -1){

		$('.m-teaser__image, .m-gallery__image, .m-boxes__image').each(function(i, obj) {

            var $thisImage = $(this);
            var $thisSrc = $thisImage.attr('src');
            var $thisClasses = $thisImage.attr('class');

            $thisImage.after('<div class="'+$thisClasses+'" style="width:100%; height:100%; background-image: url('+$thisSrc+'); background-size: cover; background-position: center;"></div>')
            $thisImage.remove();

		});

    }

	// External link
	var host = window.location.hostname;
    var domain = host.replace("www.", "");
    $('a[href^="http"]')
        .not('a[href*="' + domain + '"]')
        .attr("target", "_blank");

	/**
	* Responsive
	*/

	var browserWidth = $(window).outerWidth();
	var browserHeight = $(window).outerHeight();

	/**
	* Navigation
	*/

	var highest = -Infinity;

	$('.l-nav__submenu').each(function(index) {

		highest = Math.max( highest, parseFloat( $(this).height() ) );	

	});

	$('.l-nav__submenu-bg').css('height', highest);

	$('.l-nav__item.has-children > a').on('click', function(event) {
		event.preventDefault();
	});

	/**
	* Mobile Navigation
	*/

	$('body').on('click', '.m-hamburger', function(){

		$('.m-hamburger').toggleClass('is-clicked');

		$('.l-nav__container').toggleClass('is-open');

	});

	$('.l-nav__item.has-children').mouseover(function() {

		if ( browserWidth > 968) {

			$('.l-nav__submenu-bg').css('opacity', '1');
			$('.l-nav__submenu-bg').css('pointer-events', 'auto');
			$(this).children('.l-nav__submenu').css({'opacity':'1', 'pointer-events':'auto'});

		}

	});

	$('.l-nav__item.has-children').mouseout(function() {

		if ( browserWidth > 968) {

			$('.l-nav__submenu-bg').css('opacity', '0');
			$('.l-nav__submenu-bg').css('pointer-events', 'none');
			$(this).children('.l-nav__submenu').css({'opacity':'', 'pointer-events':''});

		}

	});

	$('.l-nav__submenu').parent('.l-nav__item').mouseover(function() {

		if ( browserWidth > 968) {

			$('.l-nav__submenu-bg').css({'opacity':'1', 'pointer-events':'auto'});

		}


	});

	$('.l-nav__submenu').parent('.l-nav__item').mouseout(function() {

		if ( browserWidth > 968) {

			$('.l-nav__submenu-bg').css({'opacity':'', 'pointer-events':''});

		}

	});

	$('body').on('click', '.l-nav__item.has-children:not(.nav-open)', function(){

		if ( browserWidth <= 968 ) {

			var $that = $(this);
			$('.l-nav__item.has-children.nav-open').not($that).removeClass('nav-open').children('.l-nav__submenu').slideUp( 325 ).removeClass('is-open');

			$that.addClass('nav-open').children('.l-nav__submenu').slideDown( 325 ).addClass('is-open');

		}	

	});	

	$('body').on('click', '.l-nav__item.has-children.nav-open', function(){

		if ( browserWidth <= 968) {

			$(this).removeClass('nav-open').children('.l-nav__submenu').slideUp( 325 ).removeClass('is-open');

		}
	
	});

	$(window).on('resize', function(){

		browserWidth = $(window).outerWidth();
		browserHeight = $(window).outerHeight();	

		if ( browserWidth <= 968 ) {	

			$('.l-nav__item.has-children').mouseover(function(e) {

				e.stopPropagation();

			});

			$('.l-nav__item.has-children').mouseout(function(e) {

				e.stopPropagation();

			});

		} else {

			$('.l-nav__container').removeClass('is-open')
			$('.l-nav__item').removeClass('nav-open');			
			$('.l-nav__submenu').removeClass('is-open').css('display', '');
			$('.m-hamburger').removeClass('is-clicked');			

		}

	});

	/**
	* Glidejs Slider
	*/	

 	if ($('.m-teaser').length) {
 
		if ( $('.m-teaser__item').length <= 1) {


			new Splide('.m-teaser', {
				autoplay: true,
				interval: 4000,
				classes: {
					pagination: 'splide__pagination m-teaser__bullets',
					page: 'splide__pagination m-teaser__bullet',
				}
			}).mount();

			$('.splide__pagination').css('display', 'none');
			$('.m-teaser__arrows').css('display', 'none');

		} else {

			new Splide('.m-teaser', {
				type: 'loop',
				autoplay: true,
				interval: 4000,
				classes: {
					pagination: 'splide__pagination m-teaser__bullets',
					page: 'splide__pagination m-teaser__bullet',
				}
			}).mount();

		}
 
 	};

  	if ($('.m-boxes--slider').length) {

	var boxesSlider = new Splide('.m-boxes--slider', {
		type: 'loop',
		perPage: 3,
		perMove: 1,
		gap: 25,
		autoplay: true,
		interval: 90000,
		pagination: false,
		breakpoints: {
			968: {
					interval: 15000,
					perPage: 2,
 				},
			680: {
					interval: 15000,
					perPage: 1,
 				}
		}
	}).mount();
 
 	};

	if ($('.m-gallery__thumbnails:not(.m-gallery__thmunbails--machine)').length) {

		var gallerySliderThumbnails = [];
		var thumbnailSlides = $('.m-gallery__thumbnails:not(.m-gallery__thumbnails--machine)');

		for (var i = 0; i < thumbnailSlides.length; i++) {

			gallerySliderThumbnails[ i ] = new Splide(thumbnailSlides[ i ], {
				isNavigation: true,
				arrows: false,
				focusAt: 'center',
				pagination: false,
				perPage: 4.5,
				gap: 12.5,
				breakpoints: {
					550: {
							destroy: true,
		 				},
				}
			}).mount();

		}

	}

	if ($('.m-gallery:not(.m-gallery--machine)').length) {
		
		var gallerySlider = [];
		var slides = $('.m-gallery:not(.m-gallery--machine)');

		for (var i = 0; i < slides.length; i++) {

			gallerySlider[ i ] = new Splide(slides[ i ] , {
				arrows: false,
				pagination: false,
				waitForTransition: false,
				autoplay: true,
				interval: 90000,
				breakpoints: {
					550: {
							autoplay: true,
							interval: 5000
					}
				}
			})

			gallerySlider[ i ].sync( gallerySliderThumbnails[ i ] ).mount();

		}


	}

	if ($('.m-gallery__thumbnails--machine').length) {

		var gallerySliderThumbnails = new Splide('.m-gallery__thumbnails--machine', {
			isNavigation: true,
			arrows: false,
			focusAt: 'center',
			pagination: false,
			perPage: 6,
			gap: 12.5,
			breakpoints: {
				768: {
						perPage: 4.5,
	 				},
	 			550: {
	 					destroy: true,
	 			}
			},
		}).mount();
		
	}

	if ($('.m-gallery--machine').length) {
		
		var gallerySlider = new Splide('.m-gallery--machine', {
			pagination: false,
			waitForTransition: false,
			autoplay: true,
			interval: 90000,
			breakpoints: {
				550: {
						autoplay: true,
						interval: 5000
				}
			}
		})

		gallerySlider.sync( gallerySliderThumbnails ).mount();

	}

	/**
	* Akkordeons
	*/

	$('body').on('click', '.m-team__header:not(.is-open), .m-akkordeon__item-header:not(.is-open), .m-jobs__item-header:not(.is-open)', function(){
		var $that = $(this);
		$('.m-team__header.is-open, .m-akkordeon__item-header.is-open, .m-jobs__item-header.is-open').not($that).removeClass('is-open').next('.m-team__members, .m-akkordeon__item-content, .m-jobs__item-content').slideUp();

		$that.addClass('is-open').next('.m-team__members, .m-akkordeon__item-content, .m-jobs__item-content').slideDown(function(){


			if ( browserWidth < 768) {

				$('html,body').animate({
					scrollTop: $that.offset().top - 90
				}, 500);

			} else if (browserWidth < 968) {

				$('html,body').animate({
					scrollTop: $that.offset().top - 130
				}, 500);

			} else {

				$('html,body').animate({
					scrollTop: $that.offset().top - 170
				}, 500);

			}
		});
	});	

	$('body').on('click', '.m-team__header.is-open, .m-akkordeon__item-header.is-open,  .m-jobs__item-header.is-open', function(){

		$(this).removeClass('is-open').next('.m-team__members, .m-akkordeon__item-content, .m-jobs__item-content').slideUp();
	
	});

	/**
	* Machine Navigation
	*/

	$('body').on('click', '.m-examples__toggle:not(.is-active)', function(){
		var $that = $(this);
		var $this = $('.m-examples__content:not(.is-visible)');
		$('.m-examples__toggle.is-active').not($that).removeClass('is-active');

		$('.m-examples__content.is-visible').not($this).removeClass('is-visible');

		$that.addClass('is-active');

		if ( $that.data('exampletype') == 'videos' ) {

			$('.m-examples__content--videos').addClass('is-visible');

		} 

		else if ( $that.data('exampletype') == 'uses' ) {

			$('.m-examples__content--uses').addClass('is-visible');

		} else {

			$('.m-examples__content--images').addClass('is-visible');

		}		

	});	

	$('body').on('click', '.m-boxes__more', function(){
		var $that = $(this);
	
		if($that.hasClass('is-clicked')) {
			$('.m-boxes__boxwrapper--last').slideUp();
			$that.removeClass('is-clicked');
			$that.children('#ShowMore').removeClass('is-hidden').next().addClass('is-hidden');
		} else {
			$('.m-boxes__boxwrapper--last').slideDown();;
			$that.addClass('is-clicked').parent();
			$that.children('#ShowLess').removeClass('is-hidden').prev().addClass('is-hidden');
		}
	});

	if (browserWidth <= 968) {

		$('.m-boxes--uses').children('.m-boxes__box:nth-child(4)').addClass('is-moved-1').prependTo('.m-boxes__boxcontainer');

	}

	if (browserWidth <= 768) {

		$('.m-boxes--uses').children('.m-boxes__box:nth-child(3)').addClass('is-moved-2').prependTo('.m-boxes__boxcontainer');

	}

	$(window).on('resize', function(){

		if (browserWidth <= 968) {

			$('.m-boxes--uses').children('.m-boxes__box:nth-child(4)').addClass('is-moved-1').prependTo('.m-boxes__boxcontainer');

		}

		if (browserWidth <= 768) {

			$('.m-boxes--uses').children('.m-boxes__box:nth-child(3)').addClass('is-moved-2').prependTo('.m-boxes__boxcontainer');

		}

		if (browserWidth >= 769) {

			$('.m-boxes__boxcontainer').children('.m-boxes__box.is-moved-2').removeClass('is-moved-2').insertAfter('.m-boxes--uses > .m-boxes__box:nth-child(2)');

		}

		if (browserWidth >= 969) {

			$('.m-boxes__boxcontainer').children('.m-boxes__box.is-moved-1').removeClass('is-moved-1').insertAfter('.m-boxes--uses > .m-boxes__box:nth-child(3)');

		}

	});

	/**
	* Forms
	*/

	$('body').on('click', '.m-form__checkbox--shipping', function(){

		if($('.m-form__checkbox--shipping').is(':checked')) {

			$('.m-form__label--shipping').addClass('is-visible');

		} else {

			$('.m-form__label--shipping').removeClass('is-visible');				

		}

	});

	if($('.m-form__button-moreparts').is(':checked')) {

		$(this).addClass('is-hidden');

	}

	var $i = 0;

	$('body').on('click', '.m-form__button-moreparts > input[type="checkbox"]', function(){

		$i++;

		$('.m-form__parts-'+ $i +'').addClass('is-visible');

		$('.m-form__button-moreparts-'+ $i +'').addClass('is-hidden');

	});

	/**
	* Fancybox
	*/
	/*
	$('.m-downloads__file--documents').fancybox({
		width: 1000,
		height: 1300,
		type: 'iframe',
		toolbar: true,
		idleTime: false,
		buttons: [
			'download',
			'close'
		],
		iframe: {
			preload: false
		},
	  	baseTpl:
			'<div class="fancybox-container" role="dialog" tabindex="-1">' +
			'<div class="fancybox-bg"></div>' +
			'<div class="fancybox-inner">' +
			'<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
			'<div class="fancybox-toolbar">{{buttons}}</div>' +
			'<div class="fancybox-navigation">{{arrows}}</div>' +
			'<div class="fancybox-stage">' +
			'<div class="fancybox-caption"><div class="fancybox-caption__body"></div></div>' +
			'</div>' +
			'</div>' +
			'</div>',
		btnTpl: {
			download:
				'<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;">' +
				'<img src="/site/themes/rontech_miux/dist/images/ic-download.svg" alt="Download">' +
				"</a>",
			close:
				'<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
				'<span class="fancybox-close--icon"></span>' +
				"</button>",
		},
		afterLoad : function(instance, current) {

			var src = current.src;

			$('[data-fancybox-download]').attr('href', src).css('display', 'inline-block');

			$('.fancybox-content').append('<div class="fancybox-content-header"></div>' );
			$('.fancybox-content-header').append( $('.fancybox-caption'), '<div class="fancybox-buttons"></div>' );
			$('.fancybox-buttons').append( $('[data-fancybox-download]'), $('[data-fancybox-close]') );

		}

	});*/

	$('.m-downloads__file--videos-external, .m-boxes__fancybox').fancybox({
		width: 1000,
		height: 562.5,
		idleTime: false,
		iframe: {
			preload: false
		},
		buttons: [
			'close'
		],
	  	baseTpl:
		    '<div class="fancybox-container" role="dialog" tabindex="-1">' +
		    '<div class="fancybox-bg"></div>' +
		    '<div class="fancybox-inner">' +
		    '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
		    '<div class="fancybox-toolbar">{{buttons}}</div>' +
		    '<div class="fancybox-navigation">{{arrows}}</div>' +
		    '<div class="fancybox-stage">' +
		    '<div class="fancybox-caption"><div class="fancybox-caption__body"></div></div>' +
		    '</div>' +
		    '</div>' +
		    '</div>',
		btnTpl: {
			download:
				'<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;">' +
				'<img src="/site/themes/rontech_miux/dist/images/ic-download.svg" alt="Download">' +
				"</a>",
			close:
				'<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
				'<span class="fancybox-close--icon"></span>' +
				"</button>",
		},
		afterLoad : function(instance, current) {

			var src = current.src;
			var cutURL = src.substring(src.lastIndexOf('/') + 1);
			var YoutubeID = cutURL.split('?')[0];
			console.log(YoutubeID);

			$('[data-fancybox-download]').attr('href', src).css('display', 'inline-block');

			$('.fancybox-content').append('<div class="fancybox-content-header"></div>' );
			$('.fancybox-content-header').append( $('.fancybox-caption'), '<div class="fancybox-buttons fancybox-buttons--nodownload"></div>' );
			$('.fancybox-buttons').append( $('[data-fancybox-close]') );

		}
	});

	/*
	$('.m-downloads__file--videos-internal').fancybox({
		width: 1000,
		height: 562.5,
		idleTime: false,
		buttons: [
			'close',
			'download'
		],
		video: {
			tpl: 
				'<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}">' +
					'<source src="{{src}}" type="{{format}}">' +
					'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
				'</video>',
			autoStart: false
		},
	  	baseTpl:
		    '<div class="fancybox-container" role="dialog" tabindex="-1">' +
		    '<div class="fancybox-bg"></div>' +
		    '<div class="fancybox-inner">' +
		    '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
		    '<div class="fancybox-toolbar">{{buttons}}</div>' +
		    '<div class="fancybox-navigation">{{arrows}}</div>' +
		    '<div class="fancybox-stage">' +
		    '<div class="fancybox-caption"><div class="fancybox-caption__body"></div></div>' +
		    '</div>' +
		    '</div>' +
		    '</div>',
		btnTpl: {
			download:
				'<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;">' +
				'<img src="/site/themes/rontech_miux/dist/images/ic-download.svg" alt="Download">' +
				"</a>",
			close:
				'<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
				'<span class="fancybox-close--icon"></span>' +
				"</button>",
		},
		afterLoad : function(instance, current) {

			var src = current.src;

			$('[data-fancybox-download]').attr('href', src).css('display', 'inline-block');

			$('.fancybox-content').append('<div class="fancybox-content-header"></div>' );
			$('.fancybox-content-header').append( $('.fancybox-caption'), '<div class="fancybox-buttons fancybox-buttons--nodownload"></div>' );
			$('.fancybox-buttons').append( $('[data-fancybox-close]') );

		}
	});
	*/

});